<template>
    <div class="page-banner-setting-edit">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">後臺設置</div>
            <div class="breadcrumb-item">Banner設置 修改</div>
        </div>

        <div class="pg-block">
            <Spin fix class="pg-sub-loading" v-if="isSubmiting">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>

            <div class="pg-form-wrap">
                <Row>
                    <Col span="18" push="5">
                        <Form :label-width="150">
                            <Row>
                                <Col span="14">
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>圖片名稱</span>
                                        </div>
                                        <Input v-model="form.name"/>
                                    </FormItem>

                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <span>預覽當前圖片</span>
                                        </div>
                                        <div class="form-upload-img">
                                            <div class="img-preview">
                                                <img :src="form.url" alt="">
                                            </div>
                                        </div>
                                    </FormItem>

                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>更新後的圖片</span>
                                        </div>
                                        <div class="form-upload-img">
                                            <div class="img-preview" v-if="uploadFile.base64">
                                                <img :src="uploadFile.base64" alt="">
                                            </div>
                                            <Upload :before-upload="handleBeforeUpload"
                                                    accept="image/png, image/jpg, image/jpeg"
                                                    action="">
                                                <div class="upload-btn">選擇圖片</div>
                                            </Upload>
                                            <div class="upload-tip">首頁輪播(尺寸：702px*243px，格式：png、jpeg)</div>
                                            <div class="upload-tip">廣告輪播(尺寸：702px*170px，格式：png、jpeg)</div>
                                        </div>
                                    </FormItem>

                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>跳至頁面</span>
                                        </div>
                                        <Input v-model="form.path"/>
                                    </FormItem>

                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>排序號</span>
                                        </div>
                                        <Input v-model="form.index"/>
                                    </FormItem>
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>類型</span>
                                        </div>
                                        <div>
                                            <RadioGroup v-model="form.type">
                                                <Radio label="1">
                                                    <span>首頁輪播</span>
                                                </Radio>
                                                <Radio label="2">
                                                    <span>廣告輪播</span>
                                                </Radio>
                                            </RadioGroup>
                                        </div>
                                        <!-- <span style="color: #999">（1：首頁輪播，2：廣告輪播。默认不填为：1）</span> -->
                                    </FormItem>
                                </Col>
                            </Row>

                            <FormItem>
                                <div class="pg-btn-wrap">
                                    <div class="pg-btn style1" @click="handleCheckForm">確認添加</div>
                                    <div class="pg-btn" @click="handleBack">返回</div>
                                </div>
                            </FormItem>
                        </Form>
                    </Col>
                </Row>
            </div>
        </div>
    </div>
</template>

<script>
   export default {
      data() {
         return {
            uploadFile: {
               file: '',
               base64: ''
            },
            isSubmiting: false,
            form: {
               name: '',   //名称
               url: '',    //图片路径
               path: '',    //跳转地址,
               index: '',  //排序number
               type: '1' // 图片类型
            }
         };
      },
      mounted() {
         this.pageParam = this.$route.query;
         this.getDetail();
      },
      methods: {
         handleBack() {
            this.$router.go(-1);
         },
         getDetail() {
            this.isSubmiting = true;
            this.$Rq.requestAuth({
               url: this.$Api.bannerlistRead,
               method: 'get',
               data: {
                  'id': this.pageParam.id
               }
            }).then((res) => {
               this.isSubmiting = false;

               if (res.code == 0) {
                  let resData = res.data[0];
                  this.form = {
                     name: resData.name,   //名称
                     url: resData.url,    //图片路径
                     path: resData.path,    //跳转地址,
                     index: resData.index,  //排序number
                     type: resData.type + '' // 图片类型
                  };
               }
            }).catch((err) => {
               this.isSubmiting = false;
            });
         },

         handleBeforeUpload(file)  //上传
         {
            this.uploadFile.file = file;
            this.hanldeImgToBase64();
            return false;
         },
         hanldeImgToBase64() {
            let file = this.uploadFile.file;

            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
               let _base64 = reader.result;
               this.uploadFile.base64 = _base64;
            };

         },
         handleUploadImg() {
            if (this.uploadFile.file === '') {
               let form = this.form;
               this.isSubmiting = true;

               this.$Rq.requestAuth({
                  url: this.$Api.bannerEdit + '/' + this.pageParam.id,
                  method: 'post',
                  data: {
                     name: form.name,
                     url: '',
                     path: form.path,
                     index: form.index,
                     type: form.type
                  }
               }).then((res) => {
                  this.isSubmiting = false;

                  if (res.code == 0) {
                     this.$Utils.showSuccess(res.msg);

                  } else {
                     this.$Utils.showTipInfo(res.msg);
                  }
               }).catch((err) => {
                  this.isSubmiting = false;
               });
            }
            if (this.uploadFile.file !== '') {
               this.isSubmiting = true;
               let formData = new FormData();
               formData.append('file', this.uploadFile.file);

               this.$Rq.requestAuth({
                  url: this.$Api.uploadImg,
                  method: 'post',
                  data: formData,
                  headers: {
                     'Content-Type': 'multipart/form-data',
                  }
               }).then((res) => {
                  this.isSubmiting = false;
                  if (res.code == 0) {
                     this.form.url = res.data.url;
                     this.handleSubmit();

                  } else {
                     this.$Utils.showTipInfo(res.msg);
                  }
               }).catch((err) => {
                  this.isSubmiting = false;
               });
            }
         },
         handleCheckForm() {
            let form = this.form;
            let uploadFile = this.uploadFile;

            if (form.name === '') {
               this.$Utils.showTipInfo('請輸入圖片名稱');
               return;
            } else if (form.path === '') {
               this.$Utils.showTipInfo('請輸入跳至頁面');
               return;
            } else if (form.index === '') {
               this.$Utils.showTipInfo('請輸入排序號');
               return;
            } else if (uploadFile.file === '' && form.url === '') {
               this.$Utils.showTipInfo('請選擇圖片');
               return;
            }
            this.handleUploadImg();
         },
         handleSubmit() {
            let form = this.form;
            this.isSubmiting = true;

            this.$Rq.requestAuth({
               url: this.$Api.bannerEdit + '/' + this.pageParam.id,
               method: 'post',
               data: {
                  name: form.name,
                  url: form.url,
                  path: form.path,
                  index: form.index,
                  type: form.type
               }
            }).then((res) => {
               this.isSubmiting = false;

               if (res.code == 0) {
                  this.$Utils.showSuccess(res.msg);

               } else {
                  this.$Utils.showTipInfo(res.msg);
               }
            }).catch((err) => {
               this.isSubmiting = false;
            });
         }
      }
   };
</script>

<style lang="scss" scoped>
    @import "BannerSettingEdit.scss";
</style>
